import React from 'react';
import Seo from '../../components/utils/Seo';
import BodyAboutPage from './body/BodyAboutPage'
import Footer from '../../components/marketing/footer/Footer';
import NavBar from '../../components/marketing/navbar/NavBar';
import HeaderAbout from '../../components/marketing/pageSections/about/HeaderAbout';


function About(props) {
    return (
        <div className="selection:bg-primary selection:text-white">
            <Seo
                title="Rita traduis des documents, sites web en plusieurs langues"
                description="Rita la spécialiste en traduction des langues. rita vous propose plusieurs services pour traduire vos documents et sites web"
            />
            <NavBar />
            <HeaderAbout />
            <BodyAboutPage />
            <Footer />
        </div>
    );
}

export default About;